import { jsx } from 'panel';
import { UserIconEl } from 'common/widgets/user-icon';
import { TrackedUserIconEl } from 'common/widgets/tracked-user-icon';
import { UserType } from './constants';
export function template() {
  const max = this.attr("show-max") >= 0 ? this.attr("show-max") : 0;
  const allUsers = this.attr("users") || [];
  const usersToShow = allUsers.slice(0, max).reverse();
  const extraUsersCount = this.attr("user-count-override") || Math.max(allUsers.length - usersToShow.length, 0);
  const icons = usersToShow.map(user => {
    const Icon = user.type === UserType.Tracked ? TrackedUserIconEl : UserIconEl;
    return jsx(Icon, {
      class: {
        clickable: this.attr("clickable")
      },
      attrs: Object.assign(Object.assign({}, user), {
        'disable-tooltip': this.attr("disable-tooltip"),
        'tooltip-placement': this.attr("tooltip-placement"),
        size: this.attr("size")
      }),
      on: {
        click: this.attr("clickable") ? () => this.helpers.handleUserIconClick(user) : null
      }
    });
  });
  const moreText = extraUsersCount ? jsx("div", {
    sel: '.more-text',
    class: {
      clickable: this.attr("clickable")
    },
    on: {
      click: this.attr("clickable") ? this.helpers.handleMoreTextClick : null
    }
  }, "+ ", extraUsersCount, " ", this.attr("more-text")) : null;
  return jsx("div", {
    sel: '.users-list'
  }, jsx("div", {
    sel: '.icon-container'
  }, icons), moreText);
}